class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.modal = this.classList.contains('modal');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]:not([data-glide-arrow])').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.stickyBar = document.querySelector('sticky-bar');
    this.upsells = this.querySelector('cart-upsell');
  }

  open() {
    this.notification.classList.add('animate', 'active');
    if (this.modal) {
      this.classList.add('open');
      document.getElementById('shopify-section-header').classList.add('modal-open');
      document.body.classList.add('no-scroll');

      //add outside click handler
      //mousedown to pervent trigger from slider grab and slide that goes out of the modal.
      this.addEventListener('mousedown', (event) => {
        if (event.target === this) this.close();
      });
    }

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      {once: true}
    );

    document.body.addEventListener('click', this.onBodyClick);

    const updateGlide = new CustomEvent('updateGlide', {
      detail: [
        {
          id: 'cart-shade-upsell'
        }
      ]
    });
    document.dispatchEvent(updateGlide);

    // hide sticky bar if in PDP and sticky bar is visible
    if (this.stickyBar && this.stickyBar.classList.contains('visible')) this.stickyBar.hide();
  }

  close() {
    this.notification.classList.remove('active');
    if (this.modal) {
      this.classList.remove('open');
      document.getElementById('shopify-section-header').classList.remove('modal-open');
      document.body.classList.remove('no-scroll');
    }
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
    // make sticky bar visible if it's in position where it's supposed to be visible
    if (this.stickyBar) this.stickyBar.checkPosition();
  }

  renderContents(parsedState, productData) {
    this.cartItemKey = parsedState.key ? parsedState.key : parsedState.items[0].key;

    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    this.upsells.reInitialize(productData);
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
